import React, { useState } from "react";
import { KTSVG } from "../../../helpers";

type Props = {
  className: string;
  innerPadding?: string;
};

const StepContent22: React.FC<Props> = ({ className, innerPadding = "" }) => {
  const [category, setCategory] = useState("1");
  const [option, setOption] = useState("1");
  const [fleet, setFleet] = useState("1");
  return (

      <div className={`card ${className}`}>
        {/* begin::Body */}
        <div className={`card-body ${innerPadding}`}>
          {/* begin::Title */}
          <div className="mb-10">
            <h3 className="fw-bold text-dark mb-2 fs-3">Define the minimum viable business product (MVBP)</h3>
            <span className="fs-7 text-muted">
             Read each section and then fill in your answers at the bottom.
            </span>
          </div>
          {/* end::Title */}

          {/* begin::Section */}
          <div className="mb-10">
            <div className="accordion" id="kt_accordion_1">
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_1">
                  <button
                    className="accordion-button fs-7 fw-bold"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_1"
                    aria-expanded="true"
                    aria-controls="kt_accordion_1_body_1"
                  >
                    Define the minimum viable business product (MVBP)
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_1"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_1"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  In this step you will integrate your assumptions into a systems test, consisting of the minimal product that a customer will still pay for.

Now, that you are feeling good about your product, you will launch a minimally viable product that a customer will pay for, but keep the functionality as simple as possible so you can minimize risks and also continue to test the assumptions in a scientific manner. You have previously tested individual elements of your business; however, the Minimum Viable Business Product (MVBP) represents a systems test of a product that actually provides value to the customer. The paying customer can use this to start a feedback loop that helps you iterate better versions of the product.
                  </div>
                </div>
              </div>
              <div className="accordion-item">
                <h2 className="accordion-header" id="kt_accordion_1_header_2">
                  <button
                    className="accordion-button fs-7 fw-bold collapsed"
                    type="button"
                    data-bs-toggle="collapse"
                    data-bs-target="#kt_accordion_1_body_2"
                    aria-expanded="false"
                    aria-controls="kt_accordion_1_body_2"
                  >
                    Defining the MVBP
                  </button>
                </h2>
                <div
                  id="kt_accordion_1_body_2"
                  className="accordion-collapse collapse show"
                  aria-labelledby="kt_accordion_1_header_2"
                  data-bs-parent="#kt_accordion_1"
                >
                  <div className="accordion-body">
                  The Lean Startup definition of what a Minimum Viable Product is too limited and does not accurately describe a “product”. The MVBP combines your most important key individual assumptions into one integrated product that can be sold. The MVBP sets you up to test the most important overarching assumption that integrates the rest—that customers will pay for your product.

There are three core elements necessary to have a Minimum Viable Business Product. All three must be present for this step to be successfully completed (for business models relying on different types of customers, these conditions may be satisfied by either type, as long as the business model still makes sense):

The customer gets value out of use of the product.
The customer pays for the product.
The product is sufficient to start the customer feedback loop, where the customer can help you iterate toward an increasingly better product.
                  </div>
                </div>
              </div>

            </div>
          </div>
          {/* end::Section */}

        </div>
        {/* end: Card Body */}
      </div>
      
  );
};

export { StepContent22 };
